import { isPreprod, isProd } from '@telialt/utils/src/helpers';

export const getSdkKey = () => {
    if (isProd()) {
        return 'R2Ere9yKJGVPLgH68Lm6D';
    } else if (isPreprod()) {
        return 'GnPU2ciVjvR2xHz2oWvPr';
    } else {
        return '3cVhEKPAtDatyXtMq6ebF';
    }
};
